import React, { useState } from 'react';
import UI from '../ui';
import { CampaignButtonPosition } from './MarketingCampaign.enum';

const { WrappedButton } = UI;

const MarketingButton = ({
	buttonType,
	buttonText,
	buttonColor,
	buttonHoverColor,
	buttonTextColor,
	triggerCampaignAction,
}) => {
	const [hover, setHover] = useState(false);

	const onHover = () => {
		setHover(prevState => !prevState);
	};

	return (
		<WrappedButton
			className={`${buttonType}-button`}
			style={{
				backgroundColor: hover ? buttonHoverColor : buttonColor,
				borderColor: hover ? buttonHoverColor : buttonColor,
				color: buttonTextColor,
			}}
			label={buttonText}
			onMouseEnter={onHover}
			onMouseLeave={onHover}
			onClick={() => triggerCampaignAction(CampaignButtonPosition.Primary)}
			dataqa="marketing"
		/>
	);
};

export default MarketingButton;
